import React from "react";
import { Breadcrumb, Layout, message } from "antd";
import { useLocation, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import AppHeader from "../Header/header";
import AppFooter from "../Footer/footer";

import StaticSeoManager from "../../Common/staticSEOManager";

const { Content } = Layout;

const AppLayout = ({ children }) => {
  const location = useLocation();

  const pathSnippets = location.pathname.split("/").filter(Boolean);

  const breadcrumbItems = [
    {
      title: (
        <Link to="/" style={{ color: "black", fontStyle: "italic" }}>
          Home
        </Link>
      ),
    },
    ...pathSnippets.map((segment, index) => {
      const url = "/" + pathSnippets.slice(0, index + 1).join("/");
      return {
        title: (
          <Link to={url} style={{ color: "black", fontStyle: "italic" }}>
            {segment.charAt(0).toUpperCase() + segment.slice(1)}
          </Link>
        ),
      };
    }),
  ];

  return (
    <HelmetProvider>
      <Layout style={{ minHeight: "100vh", backgroundColor: "#FFFFFF" }}>
        <StaticSeoManager />

        <AppHeader />

        {/* <Content style={{ margin: "16px 8vw" }}> */}
        <Content style={{ margin: "0 8vw" }}>
          {/* <Breadcrumb
          items={breadcrumbItems}
          separator=">"
          style={{ marginBottom: 16 }}
        /> */}
          {children}
        </Content>

        <AppFooter />
      </Layout>
    </HelmetProvider>
  );
};

export default AppLayout;
